
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $99c46617e77a6080$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["krNw4","index.f019de0c.js","2CIEi","mask_milk.eda5e59d.png","hMTEl","asteroid.a8fb6574.png","k6uL5","sunFlare.423e4c0c.png","iuKpR","halley.59160344.glb","5qXGp","galaxy.860bf10e.png","eQFAf","nx.a35ec1fa.png","gleU0","ny.ff0cfcd6.png","86fEI","nz.35df87fb.png","lTSZI","px.44411cf2.png","hS2vq","py.1744dd4a.png","dzSQU","pz.13ba4871.png","dvlyX","mercury_map.b0267628.jpg","2vDZ2","mercury_bump_map.1471d270.jpg","dj62Q","venus_map.08045f56.jpg","lnkft","venus_atm_map.6b67833a.jpg","ioPX7","psoj_map.52d454a5.png","1Ejrt","earth_map.d8fe9c5e.jpg","7Nwsg","earth_specular_map.1ce0e7ba.png","jq0AD","earth_night_map.de26eeef.jpg","l2VgZ","earth_normal_map.87a857b8.png","4nojX","earth_clouds_map.f968c271.jpg","9mWCy","moon_map.58b05f29.jpg","av3RQ","moon_normal_map.0033ad88.jpg","fqor9","mars_map.848cd1d5.png","1MqcD","mars_bump_map.2fdca6b7.png","eGYoG","saturn_map.024c2f02.jpg","ckzkf","dione_map.edce9b5f.png","drerS","iapetus_map.fb410108.png","lUfEk","rhea_map.ac8658c5.jpg","44Kvb","titan_map.9e7068c4.png","1zsow","tethys_map.ab09f522.png","kPUhs","mimas_map.6f551ca1.png","7FrNa","dione_bump_map.e3229a3d.png","sqi8o","iapetus_bump_map.8cdbe508.png","ecmVV","rhea_bump_map.f347c9f9.png","kdC5L","titan_bump_map.e2d30a97.png","7PYJs","tethys_bump_map.bfc79c05.jpg","9i4ZY","mimas_bump_map.70a7b653.jpg","ftdaX","jupiter_map.4cbea6d5.jpg","czQHi","europa_map.d197b19b.jpg","5stDJ","callisto_map.1223f1b1.jpg","fEMIA","ganymede_map.88904da0.jpg","6eNS3","io_map.33822081.jpeg","8Wd8W","europa_bump_map.fe1234b4.png","JM5lt","callisto_bump_map.b07fd47f.jpg","hxJWJ","ganymede_bump_map.39029d93.jpg","iBdAo","io_bump_map.63f3c80d.png","54bD7","saturn-rings.079a701d.png","bmGlY","uranus_rings.cfe73dfa.png","dl4b3","jupiter_rings.615e34b5.png","1YtcD","neptune_rings.6617a5fd.png","o4sR8","uranus_map.d1e141cb.jpg","cQ0NO","titania_map.b394cf6a.png","bQj5i","umbriel_map.8e10c1b6.png","4QzXS","oberon_map.d790ead0.png","eeCXR","ariel_map.8503c245.png","2wJbt","miranda_map.9f1e7fe4.png","icZ1F","titania_bump_map.26253771.png","iKM4L","umbriel_bump_map.9a95590a.png","i7V6G","oberon_bump_map.53dfd480.png","9EQeX","ariel_bump_map.c015d38d.png","bNA3V","miranda_bump_map.51cb1072.png","6DM5p","neptune_map.2330f4df.jpg","70FNB","triton_map.d53addfd.jpg","cSmSl","triton_bump_map.a2970b33.jpg","a76mV","pluto_map.5ee9986f.png","j6vZ0","pluto_bump_map.ba849f41.jpg","i3cW0","charon_map.b8b76188.jpg","1mES7","charon_bump_map.49e72aa1.png","eWAct","icon_mag.3fcfbf3c.png","gGmLO","icon_wind.c94de040.png","kr3Js","icon_spacetime.1b475129.png","dFgdM","nx.35d4c373.png","cpAQg","ny.9ac4ce79.png","k9goI","nz.864a54ec.png","6n3mR","px.8f6a4b5e.png","5gOm8","py.39ecfa6d.png","3J3ev","pz.5d28646a.png"]'));


//# sourceMappingURL=index.runtime.c47379e0.js.map
